import customAxios from '../../actions/customAxios';

//.........................cuctomAxios...........................

export const requestForgottenPasswordChange = (mobPhone, email) => {
    const body = {mobPhone, email};
  
    const url = '/syws-auth/forgotenPassword/request';
  
    return customAxios.post(url, body);
  }
  
  export const authorizeForgottenPasswordChange = (otp, authRequestId, password) => {
    const body = {otp, authRequestId, password}
  
    const url = '/syws-auth/forgotenPassword/authorize';
  
    return customAxios.post(url, body);
  }